import React from 'react'
import {
    CheckOutlined,
    CloseOutlined,
    LoadingOutlined,
    FieldTimeOutlined
  } from "@ant-design/icons";
const InterviewRoundsIndicator = ({round}) => {
  return (
    <span className="details-info">
    {round !== "Selected" &&
      round !== "Rejected" && (
        <>
          {round}{" "}
          {round && (
            <span className="bg-warning text-white d-inline-flex p-1 rounded-circle mr-2">
              <FieldTimeOutlined />
            </span>
          )}
        </>
      )}
    {round === "Selected" && (
      <>
        {round}{" "}
        {round && (
          <span className="bg-success text-white d-inline-flex p-1 rounded-circle mr-2">
            <CheckOutlined />
          </span>
        )}
      </>
    )}
    {round === "Rejected" && (
      <>
        Not Selected{" "}
        {round && (
          <span className="bg-danger text-white d-inline-flex p-1 rounded-circle mr-2">
            <CloseOutlined />
          </span>
        )}
      </>
    )}{" "}
  </span>
  )
}

export default InterviewRoundsIndicator